/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/
import { useCallback } from 'react';


import * as React from 'react';
import { Badge, IconButton, Tooltip } from '@mui/material';
import { BsFillPeopleFill } from 'react-icons/bs'; 
import { useEffect } from 'react';
import { getKeycloakUsersCount } from '../../../../../../services/keycloak/keycloak';
 

const KeycloakUserCount = () => {
    const [usersCount, setUsersount] = React.useState(0);
 
    const fetchUsers = useCallback(async () => {
         try {
            const counts = await getKeycloakUsersCount({"realm":"getchkd"});
             setUsersount(counts);
         } catch (error) {
         }
    }, []);
    useEffect(() => {
        fetchUsers();
    }, [fetchUsers]);

    return (
        <>
            <Tooltip title="Keycloak Users Count" placement="left" arrow>
                <div style={{ float: 'right', marginRight: '20px' }}>
                    <IconButton color="primary" style={{ backgroundColor: '#36d7914a' }}>
                        <Badge badgeContent={usersCount} color="success">
                            <BsFillPeopleFill />
                        </Badge>
                    </IconButton>
                </div>
            </Tooltip>
        </>
    )

}

export default KeycloakUserCount;
